'use client';

import * as layout from '@ocodelib/compose-layout';
import { useEffect, useRef, useState } from 'react';
import { buildLayout } from './layout/build-layout';
import { LayoutRoot } from './layout/LayoutRoot';
import { P5BasicAppProvider } from './P5BasicAppProvider';
import type { IAppConfig, IP5BasicLayoutConfig, P5BasicAppType } from './types';

interface Props {
  appConfig: IAppConfig;
  onLayoutBuild?: (layoutManager: layout.ComposeLayoutManager) => void;
  onLoadApp?: (app: P5BasicAppType | null) => void;
}

export function P5BasicAppUi(props: Props) {
  const { appConfig, onLoadApp } = props;
  const onLayoutBuildRef = useRef(props.onLayoutBuild);
  onLayoutBuildRef.current = props.onLayoutBuild;

  const [appInfo, setAppInfo] = useState<{
    layoutManager: layout.ComposeLayoutManager;
    layoutConfig: IP5BasicLayoutConfig;
  }>();

  useEffect(() => {
    const { dispose, result } = buildLayout(onLayoutBuildRef.current);
    setAppInfo(result);
    return () => {
      dispose();
      setAppInfo(undefined);
    };
  }, []);

  if (!appInfo) {
    return null;
  }

  return (
    <layout.ComposeLayout layoutManager={appInfo.layoutManager}>
      <P5BasicAppProvider
        layoutConfig={appInfo.layoutConfig}
        appConfig={appConfig}
        onLoadApp={onLoadApp}
      >
        <LayoutRoot />
      </P5BasicAppProvider>
    </layout.ComposeLayout>
  );
}
